import {webServicesEpics} from "../../services/ws/WServiceEpics";
import {AppActions} from "./AppActions";
import {pageDefinitions} from "./Pages/PageDefinitions";
import {Observable} from "rxjs";

import {map} from "rxjs/operators";
import {
    b64toBlob,
    combineEpics,
    errorEpics,
    infoBannerEpics,
    ofType,
    PledgerAction,
    PledgerEpic
} from "@pledger/frontend-commons";
import {pageManager} from "../../services/ui/AppPageManager";
import {navigationMenuEpics} from "../../services/ui/NavigationMenu/NavigationMenuEpics";


const showPageEpics = pageDefinitions.map(pageDefinition => pageDefinition.showEpic.epicBuilder(pageDefinition));

const replaceURLEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) =>
    actions$.pipe(
            ofType(AppActions.REPLACE_LOCATION_ACTION.type),
            map((action : PledgerAction) =>  action.payload.action )
    );

const goBackEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) =>
    actions$.pipe(
        ofType(AppActions.GO_BACK_ACTION.type),
        map((action : PledgerAction) =>  {
            action.payload.navigate(-1);
            return AppActions.EMPTY_ACTION.build();
        } )
    );

const goForwardEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) =>
    actions$.pipe(
        ofType(AppActions.GO_BACK_ACTION.type),
        map((action : PledgerAction) =>  {
            action.payload.navigate(1);
            return AppActions.EMPTY_ACTION.build();
        } )
    );


const disconnectEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) =>
    actions$.pipe(
        ofType(AppActions.DISCONNECT_ACTION.type),
        map((action) => {
            sessionStorage.removeItem('userToken');
           // sessionStorage.removeItem('registerToken');
            const urlBaseName = process.env.REACT_APP_URL_BASENAME === undefined ? '' : process.env.REACT_APP_URL_BASENAME;
            window.location.assign(urlBaseName + '/');
            return AppActions.EMPTY_ACTION.build();
        })
    );

const displayBase64DocumentEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) =>
    actions$.pipe(
        ofType(AppActions.DISPLAY_BASE64_DOCUMENT_ACTION.type),
       map((action) => {
         // const docName  = action.payload.docName;
          const docData  = action.payload.docData;
          const typeMime  = action.payload.typeMime;
          const docWindow  = action.payload.docWindow;

          const dataBlob = b64toBlob(docData,typeMime);
          // dataBlob.name=docName;
          const url = window.URL.createObjectURL(dataBlob);
          docWindow.location = url;
          docWindow.onload = () => {
              window.URL.revokeObjectURL(url);
          };
           return AppActions.EMPTY_ACTION.build();
      })
    );


export const appEpic : PledgerEpic<any> = combineEpics(
    replaceURLEpic,
    goBackEpic,
    goForwardEpic,
    ...showPageEpics,
    disconnectEpic,
    pageManager.currentPageEpics,
    errorEpics,
    infoBannerEpics,
    webServicesEpics,
     displayBase64DocumentEpic,
    navigationMenuEpics

);
